import { BELARUS, POLAND, UNITED_STATES } from 'framework/form';
import type { PositionProfileFormValues, PositionProfileOfficeId, SalaryRange } from './types';
import { CURRENCY_TYPES } from 'domain/shared/core/constants';
import { AUSTIN_OFFICE_ID, KRAKOW_OFFICE_ID, MINSK_OFFICE_ID } from 'domain/shared/employee';
import type { ChipOwnProps } from '@mui/material';

export const POSITION_PROFILES_PATH = '/position-profiles';

export const POSITION_PROFILE_STATUSES = {
  ACTIVE: 'ACTIVE',
  DEPRECATED: 'DEPRECATED',
  RETIRED: 'RETIRED',
} as const;

export const POSITION_PROFILE_STATUS_LABELS: Dictionary<string> = {
  [POSITION_PROFILE_STATUSES.ACTIVE]: 'Active',
  [POSITION_PROFILE_STATUSES.DEPRECATED]: 'Deprecated',
  [POSITION_PROFILE_STATUSES.RETIRED]: 'Retired',
};

export const DEFAULT_POSITION_PROFILE_STATUSES = [
  POSITION_PROFILE_STATUSES.ACTIVE,
  POSITION_PROFILE_STATUSES.DEPRECATED,
];

export const POSITION_FILL_REQUEST_BADLE_STATUS_COLOR: Record<
  (typeof POSITION_PROFILE_STATUSES)[keyof typeof POSITION_PROFILE_STATUSES],
  ChipOwnProps['color']
> = {
  [POSITION_PROFILE_STATUSES.ACTIVE]: 'info',
  [POSITION_PROFILE_STATUSES.DEPRECATED]: 'default',
  [POSITION_PROFILE_STATUSES.RETIRED]: 'default',
};

export const POSITION_PROFILE_STATUS_ACTIONS = {
  DEPRECATE: 'deprecate',
  REACTIVATE: 'reactivate',
  RETIRE: 'retire',
} as const;

export const POSITION_PROFILE_TIMELINE_TYPES = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  DEPRECATED: 'DEPRECATED',
  REACTIVATED: 'REACTIVATED',
  RETIRED: 'RETIRED',
  NOTE: 'NOTE',
} as const;

export const POSITION_PROFILE_OFFICES: Array<{
  officeId: PositionProfileOfficeId;
  country: string;
  currency: string;
}> = [
  { officeId: MINSK_OFFICE_ID, country: BELARUS.name, currency: CURRENCY_TYPES.USD },
  { officeId: KRAKOW_OFFICE_ID, country: POLAND.name, currency: CURRENCY_TYPES.PLN },
  { officeId: AUSTIN_OFFICE_ID, country: UNITED_STATES.name, currency: CURRENCY_TYPES.USD },
];

export const createEmptySalaryRanges = (): SalaryRange[] =>
  POSITION_PROFILE_OFFICES.map(({ officeId, country, currency }) => ({
    officeId,
    country,
    currency,
    minSalaryId: null,
    maxSalaryId: null,
    minValue: null,
    maxValue: null,
    originalMinValue: null,
    originalMaxValue: null,
  }));

export const createPositionProfileInitialFormValues = (): PositionProfileFormValues => ({
  specializationId: null,
  technologyId: null,
  competencyLevel: '',
  name: '',
  description: '',
  salaryRanges: createEmptySalaryRanges(),
});

export const POSITION_PROFILE_LIST_READ = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_LIST_READ_LIST';
export const PEOPLE_MANAGEMENT_POSITION_PROFILE_READ = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_READ';
export const POSITION_PROFILE_CREATE = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_CREATE';
export const POSITION_PROFILE_UPDATE = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_UPDATE';
export const POSITION_PROFILE_DEPRECATE = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_DEPRECATE';
export const POSITION_PROFILE_REACTIVATE = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_REACTIVATE';
export const POSITION_PROFILE_RETIRE = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_RETIRE';
export const POSITION_PROFILE_TIMELINE_ENTRY_CREATE = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_TIMELINE_ENTRY_CREATE';
export const POSITION_PROFILE_TIMELINE_LIST_READ_LIST = 'PEOPLE_MANAGEMENT_POSITION_PROFILE_TIMELINE_LIST_READ_LIST';
